// ---- zie https://medium.com/ampersand-academy/ionic-4-modal-example-da9694fa0f53
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, Form, Validators } from '@angular/forms';
import { OverlayEventDetail } from '@ionic/core';
import { ModalController, NavParams, AlertController } from '@ionic/angular';

import { AjaxService } from '../ajax.service';
import { GlobalService } from '../global.service';
import { ScanCameraPage } from '../scan-camera/scan-camera.page';
import { I18nService } from '../shared/i18n.service';
import { CameraService } from '../camera.service';
import { DatePipe } from '@angular/common';
import { RecordingData } from 'capacitor-voice-recorder';
import { VoiceMemoPage } from '../voice-memo/voice-memo.page';

interface RecordSpec {
    fld: any;
    value: any;
    descr?: string;
    typ?: string;
    tbl?: string;
    exe?: string;
    con?: string;
    valid?: boolean;
    msg?: string;
    choices?: any[];
    EditCond?: boolean;
    minDate?: Date;
    opt?: string;
    btn?: string;
}

@Component({
    selector: 'app-record-form',
    templateUrl: './record-form.page.html',
    styleUrls: ['./record-form.page.scss'],
    standalone: false,
})
export class RecordFormPage implements OnInit {
    defaults: [];
    recordFields: RecordSpec[] = [];
    table: '';
    tableDescr: '';
    id: '*NEW*';
    formValid = false;
    private recordedAudioData: RecordingData | null = null;
    private audioFileName: string | null = null;

    // Quill editor configuration
    public quillConfig = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
        ],
    };

    constructor(
        public viewCtrl: ModalController,
        private navParams: NavParams,
        private router: Router,
        public global: GlobalService,
        public alertController: AlertController,
        public modalController: ModalController,
        private ajax: AjaxService,
        private camera: CameraService,
        public i18n: I18nService,
        private datePipe: DatePipe
    ) {}

    ngOnInit() {}

    ionViewWillEnter() {
        console.log('ionViewWillEnter');
        this.defaults = this.navParams.get('defaults');
        this.table = this.navParams.get('table');
        this.id = this.navParams.get('id');
        this.ajax
            .get('recordForm', {
                table: this.table,
                id: this.id,
                defaults: this.defaults,
            })
            .then((data: any) => {
                console.log('recordFields', data);
                if (!data.login) {
                    this.viewCtrl.dismiss();
                } else {
                    data.recordFields.forEach((elt: RecordSpec, i) => {
                        if (!('valid' in data.recordFields[i])) {
                            data.recordFields[i].valid = true;
                        }
                        if (data.recordFields[i].opt.includes('limit')) {
                            const opts = data.recordFields[i].opt.split(';');
                            const minLimit: Date = new Date();
                            minLimit.setDate(minLimit.getDate() - opts[1]);
                            data.recordFields[i].minDate = minLimit;
                        } else {
                            data.recordFields[i].minDate = null;
                        }
                    });
                    this.recordFields = data.recordFields;
                    this.tableDescr = data.tableDescr;
                    this.checkForm();
                    this.evalForm();
                }
            });
    }

    customTrackBy(index: number, obj: any): any {
        return index;
    }

    doCancel() {
        this.alertController
            .create({
                header: this.i18n.tr('Bevestig cancel'),
                message: this.i18n.tr('Invoer stoppen?'),
                buttons: [
                    {
                        text: this.i18n.tr('Nee'),
                        handler: () => {
                            console.log('in dialoog blijven');
                        },
                    },
                    {
                        text: this.i18n.tr('OK'),
                        handler: () => {
                            this.viewCtrl.dismiss();
                        },
                    },
                ],
            })
            .then((res) => {
                res.present();
            });
    }

    doSubmit() {
        this.evalForm();
        if (this.formValid) {
            this.ajax
                .get('recordSave', {
                    table: this.table,
                    fields: this.recordFields,
                })
                .then((data: any) => {
                    const dismissData = {
                        ...data,
                        recordedAudio: this.recordedAudioData,
                        audioFileName: this.audioFileName,
                    };
                    this.viewCtrl.dismiss(dismissData);
                });
        }
    }

    checkForm() {
        let myCheck = true;
        this.recordFields.forEach((elt: RecordSpec, i) => {
            myCheck = myCheck && this.recordFields[i].valid;
        });
        this.formValid = myCheck;
    }

    /** bij elke wijziging in formulier uit te voeren */
    evalForm() {
        let answers = '';
        for (const rec of this.recordFields) {
            const val =
                typeof rec.value === 'string' && rec.typ !== 'N'
                    ? `'${rec.value}'`
                    : rec.value
                    ? rec.value
                    : `''`;
            answers = answers + `let ${rec.fld}=${val}; `; // hier komt het invul-antwoord
            if (rec.exe && rec.exe.length > 0) {
                console.log('Executing: ', rec.exe);
                try {
                    eval(rec.exe);
                } catch (err) {
                    console.log('catch executing ', rec.exe, err);
                }
            }
        }
        console.log('answers:', answers);

        for (const rec of this.recordFields) {
            let msg = '';
            if (rec.con.length > 0) {
                try {
                    msg = eval(
                        `(function() { let _retv = true; ${answers} _retv=(${rec.con}); return _retv; })();`
                    );
                } catch (err) {
                    console.error(err);
                }
            }
            if (rec.typ === 'D') {
                // ...
            }
            rec.valid = !msg;
            rec.msg = msg;
            if (rec.typ === 'COMBO') {
                if (rec.value) {
                    this.ajax
                        .get('exists', {
                            tbl: rec.opt,
                            val: rec.value,
                        })
                        .then((data: any) => {
                            rec.valid = data.exists;
                            rec.msg = data.exists ? '' : 'Bestaat niet.';
                        });
                } else {
                    rec.valid = true;
                    rec.msg = '';
                }
            }
            if (rec.fld === 'newID' && msg === '') {
                // speciale extra condities voor een nieuw ID veld
                if (rec.value && rec.typ !== 'N') {
                    rec.value = rec.value.replace(/[^A-Za-z0-9_-]+/g, '_');
                }
                this.ajax
                    .get('exists', {
                        tbl: this.table,
                        val: rec.value,
                    })
                    .then((data: any) => {
                        rec.valid = !data.exists;
                        rec.msg = data.exists ? 'Bestaat al.' : '';
                        this.checkForm();
                    });
            }
        }
        this.checkForm();
    }

    comboChanged(event, index: number) {
        console.log('comboChanged:', event, index);
        this.ajax
            .get('comboChoices', {
                table: this.recordFields[index].opt,
                txt: event,
            })
            .then((data: any) => {
                console.log('comboChoices:', data);
                this.recordFields[index].choices = data.choices
                    ? data.choices
                    : [];
                // this.recordFields[index]['valid'] = (this.recordFields[index]['choices'].length>0);
                this.recordFields[index].valid =
                    !this.recordFields[index].value ||
                    this.recordFields[index].choices.find(
                        (e) => e.ID === this.recordFields[index].value
                    );
                this.checkForm();
                this.evalForm();
            });
    }

    async doScan(i) {
        if (!(await this.camera.startCamera())) {
            return;
        }
        this.global.scanCamera = true;
        const myDlg = await this.modalController.create({
            component: ScanCameraPage,
        });
        myDlg.onDidDismiss().then((dataPar: OverlayEventDetail) => {
            this.global.scanCamera = false;
            if (dataPar.data.code) {
                this.recordFields[i].value = dataPar.data.code;
                this.evalForm();
            } else {
                this.recordFields[i].value = '';
                this.evalForm();
            }
        });
        return await myDlg.present();
    }

    async openVoiceMemoModal(index: number) {
        const modal = await this.modalController.create({
            component: VoiceMemoPage,
        });
        await modal.present();

        const { data, role } = await modal.onDidDismiss();

        if (role === 'confirm' && data && data.text) {
            this.recordedAudioData = data.audio;
            const berichtField = this.recordFields[index];
            const existingValue = berichtField.value || '';
            const transcribedText = data.text;

            if (
                existingValue.trim() === '<p><br></p>' ||
                existingValue.trim() === ''
            ) {
                berichtField.value = `<p>${transcribedText}</p>`;
            } else {
                berichtField.value =
                    existingValue + `<p>${transcribedText}</p>`;
            }

            const titelField = this.recordFields.find((f) => f.fld === 'Titel');
            if (titelField) {
                if (titelField.value && titelField.value.trim() !== '') {
                    titelField.value += '-Audio';
                    this.audioFileName = `${titelField.value}.wav`;
                } else {
                    const ordernr = this.defaults['LiproOrderNr'];
                    const now = new Date();
                    const formattedDate = this.datePipe.transform(
                        now,
                        'dd-MM-yy-HH-mm-ss'
                    );
                    const dynamicTitle = `Audio-Order-${ordernr}-${formattedDate}`;
                    titelField.value = dynamicTitle;
                    this.audioFileName = `${dynamicTitle}.wav`;
                }
            }
            this.evalForm();
        }
    }

    openTimePicker(input: HTMLInputElement): void {
        if (input.disabled || input.readOnly) {
            return;
        }

        try {
            if (typeof input.showPicker === 'function') {
                input.showPicker();
            }
        } catch (error) {
            console.error('Unable to open time picker:', error);
        }
    }
}
